import React from "react";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import "./proiecte-comunicate.css";

type PR = {
    id: string;
    title: string;
    url: string;          // external link
    imageUrl?: string;
    description?: string;
    date?: any;           // Firestore Timestamp
};

export default function ProiecteComunicatePage() {
    const [items, setItems] = React.useState<PR[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        (async () => {
            const q = query(collection(db, "project_press_releases"), orderBy("date", "desc"));
            const snap = await getDocs(q);
            const data = snap.docs.map(d => ({ id: d.id, ...(d.data() as any) })) as PR[];
            setItems(data);
            setLoading(false);
        })();
    }, []);

    return (
        <div className="page-container">
            <Navbar />
            <div className="page-content">
                <h1>Comunicate de presă – Proiecte</h1>

                {loading ? <p>Se încarcă…</p> : items.length === 0 ? (
                    <p>Nu există comunicate momentan.</p>
                ) : (
                    <div className="press-grid">
                        {items.map(it => (
                            <a
                                key={it.id}
                                href={it.url}
                                target="_blank"
                                rel="noreferrer"
                                className="press-card"
                            >
                                {it.imageUrl && <img src={it.imageUrl} alt={it.title} loading="lazy" />}
                                <div className="press-body">
                                    <h3>{it.title}</h3>
                                    <div className="meta">
                                        {it.date?.toDate?.() ? it.date.toDate().toLocaleDateString() : ""}
                                    </div>
                                    {it.description && <p className="desc">{it.description}</p>}
                                    <span className="cta">Deschide comunicatul →</span>
                                </div>
                            </a>
                        ))}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}